import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Social Proof',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: '150,000+',
            helperText: 'The main title.',
        },
        {
            name: 'subtitle',
            type: 'string',
            defaultValue: 'brands and creators trust Storyblocks to bring their ideas to life',
            helperText: 'Optional subtitle.',
        },
        {
            name: 'description',
            type: 'string',
            defaultValue: 'Learn why Canon, Grace Wells, Global Citizen, and others choose Storyblocks.',
            helperText: 'Optional description text to provide more context.',
        },
        {
            name: 'cards',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                    helperText: 'Image URL for the social proof card.',
                    required: true,
                    allowedFileTypes: ['jpg', 'png'],
                },
                {
                    name: 'alt',
                    type: 'string',
                    defaultValue: '',
                    helperText: 'Alternative text for the image, for accessibility.',
                    required: true,
                },
                {
                    name: 'type',
                    type: 'string',
                    defaultValue: 'creator',
                    helperText: 'Select the type of card.',
                    enum: [
                        { label: 'Logo', value: 'logo' },
                        { label: 'Creator', value: 'creator' },
                    ],
                    onChange: `(options) => {
                        const type = options.get('type');
                        if (type === 'logo') {
                            options.set('name', '');
                        }
                    }`,
                    required: true,
                },
                {
                    name: 'name',
                    type: 'string',
                    defaultValue: 'Creator Name',
                    showIf: `options.get('type') === 'creator'`,
                    helperText: 'Name of the person or brand being represented.',
                    required: true,
                },
                {
                    name: 'mobileOnly',
                    type: 'boolean',
                    defaultValue: false,
                    helperText: 'Whether to show this card only on mobile devices.',
                },
            ],
            helperText: 'List of social proof cards to display.',
            onChange: (options) => {
                if (options.get('cards').length > 14) {
                    options.set('cards', options.get('cards').slice(0, 14));
                    alert('Maximum number of cards is 14. Modify an existing card instead.');
                }
            },
        },
        {
            name: 'showCallToAction',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Whether to show a call to action button.',
        },
        {
            name: 'callToAction',
            type: 'object',
            defaultValue: {
                text: 'Read Case Studies',
                link: '/',
            },
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: 'Read Case Studies',
                    helperText: 'Text for the call to action button.',
                },
                {
                    name: 'link',
                    type: 'string',
                    defaultValue: '/',
                    helperText: 'URL for the call to action button.',
                },
            ],
            helperText: 'Configuration for the call to action button.',
        },
        {
            name: 'showHighlightedCard',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Whether to show a highlighted social proof card.',
        },
        {
            name: 'highlightedCard',
            type: 'object',
            defaultValue: {
                image: '',
                name: '',
                type: 'creator',
            },
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                    helperText: 'Image URL for the highlighted card.',
                    required: false,
                    allowedFileTypes: ['jpg', 'png'],
                },
                {
                    name: 'name',
                    type: 'string',
                    defaultValue: 'Creator Name',
                    helperText: 'Name for the highlighted card.',
                    required: false,
                },
                {
                    name: 'type',
                    type: 'string',
                    defaultValue: 'creator',
                    helperText: 'Type of the highlighted card.',
                    enum: [
                        { label: 'Logo', value: 'logo' },
                        { label: 'Creator', value: 'creator' },
                    ],
                },
            ],
            helperText: 'Configuration for the highlighted social proof card.',
        },
    ],
};
